import styled from "styled-components";
import UpArrow from "../../../assets/AssetArrow.png";
import {
  Container,
  CardContainer,
  CMdExpandMore,
  CardTitle,
  MedicalCard,
  MedicalSearch,
  MedicalTab,
  Table,
} from "../../../style/Prescription";
import PmsDispensedBilling from "./Billing/Billing";
import { Button } from "../../../style/Button";
import { useHistory } from "react-router-dom";
import { Grid } from "@material-ui/core";
import "./Billing/Bill.css";
const Paper = styled.div`
  width: 100%;
  min-height: 45px;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #c5c5c5;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 500;
`;

const Dispensed = () => {
  const history = useHistory()
  const backButtonHandler = () => {
    // history.pushState("partner")
    history.push("/Pmc/dashboard")
  }
  return (
    <div className="dispensed-page">
      <Container>
        <Grid container>
          <Grid item md={4} lg={3} xs={12}>
            <div className="paddingRight-30 dispensed-side-tabs">
              <Paper
                style={{
                  color: "#4678ED",
                  fontWeight: 600,
                  fontSize: "17px",
                  fontFamily: "work sans",
                  maxWidth: "100%",
                  width: "100%",
                  padding: "0 25px",
                }}
              >
                New Medication
                <img
                  src={UpArrow}
                  style={{
                    marginLeft: "auto",
                    marginTop: "0px",
                    width: "20px",
                  }}
                />
              </Paper>
              <Paper
                style={{
                  color: "#606060",
                  fontSize: "17px",
                  fontWeight: 600,
                  fontFamily: "work sans",
                  maxWidth: "100%",
                  width: "100%",
                  padding: "0 25px",
                }}
              >
                Medication history
                <img
                  src={UpArrow}
                  style={{
                    marginLeft: "auto",
                    marginTop: "0px",
                    width: "20px",
                    transform: "rotate(180deg)",
                  }}
                />
              </Paper>
            </div>
          </Grid>
          <Grid item md={8} lg={9} xs={12}>
            <PmsDispensedBilling />
          </Grid>
        </Grid>


      </Container>
      <div style={{ textAlign: "right", marginTop: "15px" }}>
        <Button
          className="billing-btn-outline"
          height="fit-content"
          onClick={backButtonHandler}
        >
          Back
        </Button>
      </div>
    </div>
  );
};

export default Dispensed;
